import { z } from "zod/v4";

import { castToNumber } from "../utils";

import { AvailableSubscriptionDiscountTypeList } from "./subscriptions";

export const ExperienceVariationPricesDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  variationId: z.uuid().nullish(),
  price: castToNumber.or(z.string()),
  compareAtPrice: castToNumber.or(z.string()).nullish(),
  subscriptionDiscount: castToNumber.or(z.string()).nullish(),
  subscriptionDiscountType: z
    .enum(AvailableSubscriptionDiscountTypeList)
    .nullish(),
});
export type ExperienceVariationPricesDto = z.infer<
  typeof ExperienceVariationPricesDtoSchema
>;
